import {
  GetRequestedReportsRequest,
  GetRequestedReportsResponse,
} from "@services/models/Reports/getAllRequestedReports";
import { GetDownloadUrlResponse } from "@services/models/Reports/getDownloadUrl";
import {
  RequestReportRequest,
  RequestReportResponse,
} from "@services/models/Reports/requestReport";
import { AxiosInstance } from "axios";
import { createApiClient } from "../api/createApiClient";

class ReportServices {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }
  public async requestReport(
    data: RequestReportRequest,
  ): Promise<RequestReportResponse> {
    const requestBody: Record<string, unknown> = {
      startDate: data.startDate,
      endDate: data.endDate,
      reportType: data.reportType,
    };

    if (data.merchantId !== undefined && data.merchantId !== -1) {
      requestBody.merchantId = data.merchantId;
    } else if (data.userId !== undefined) {
      requestBody.userId = data.userId;
    }

    const response = await this.api.post<RequestReportResponse>(
      "/analyticsDashboard/requestReport",
      requestBody,
    );

    return response.data;
  }

  public async getAllRequestedReports(
    data: GetRequestedReportsRequest,
  ): Promise<GetRequestedReportsResponse> {
    const params: Record<string, number> = {};

    if (data.merchantId !== undefined && data.merchantId !== -1) {
      params.merchantId = data.merchantId;
    } else if (data.userId !== undefined) {
      params.userId = data.userId;
    }

    const response = await this.api.get<GetRequestedReportsResponse>(
      "/analyticsDashboard/getAllRequestedReports",
      {
        params,
      },
    );

    return response.data;
  }

  public async getReportDownloadUrl({
    requestId,
    merchantId,
    userId,
  }: {
    requestId: number;
    merchantId?: number;
    userId?: number;
  }): Promise<GetDownloadUrlResponse> {
    const params: Record<string, number> = {
      requestId,
    };

    if (merchantId !== undefined && merchantId !== -1) {
      params.merchantId = merchantId;
    } else if (userId !== undefined) {
      params.userId = userId;
    }

    const response = await this.api.get<GetDownloadUrlResponse>(
      "/analyticsDashboard/getReportDownloadUrl",
      {
        params,
      },
    );

    return response.data;
  }
}
export const reportApiServices = new ReportServices();
